import { Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { InputMaskModule } from 'primeng/inputmask';

@Component({
  selector: 'app-time-type',
  imports: [
    ReactiveFormsModule, FormsModule, FormlyModule, InputMaskModule
  ],
  templateUrl: './time-type.type.html',
  styleUrl: './time-type.type.scss',
})
export class TimeType extends FieldType<FieldTypeConfig> implements OnInit {
  timeValue: string = '';
  hasFocus = false;
  isInvalid = false;

  ngOnInit(): void {
    this.syncFromFormControl();
  }

  private syncFromFormControl(): void {
    const value = this.formControl.value;
    this.timeValue = value || '';
  }

  onFocus(): void {
    this.hasFocus = true;
  }

  onBlur(): void {
    this.hasFocus = false;
    this.formControl.markAsTouched();

    // Si tiene valor incompleto, limpiar
    if (this.timeValue && this.timeValue.includes('_')) {
      this.timeValue = '';
      this.formControl.setValue(null);
      this.isInvalid = false;
    }
  }

  onTimeChange(value: string): void {
    this.timeValue = value;

    // Si está vacío o incompleto
    if (!value || value.includes('_')) {
      this.formControl.setValue(null);
      this.isInvalid = false;
      return;
    }

    // Validar hora
    if (this.isValidTime(value)) {
      this.isInvalid = false;
      this.formControl.setValue(value);
      this.formControl.markAsDirty();
    } else {
      this.isInvalid = true;
      this.formControl.setValue(null);
    }
  }

  onComplete(): void {
    if (this.timeValue && !this.timeValue.includes('_')) {
      if (this.isValidTime(this.timeValue)) {
        this.isInvalid = false;
        this.formControl.setValue(this.timeValue);
        this.formControl.markAsDirty();
      } else {
        this.isInvalid = true;
        this.formControl.setValue(null);
      }
    }
  }

  private isValidTime(value: string): boolean {
    if (!value || value.length !== 5 || value.includes('_')) return false;
    const [hoursStr, minutesStr] = value.split(':');
    const hours = parseInt(hoursStr, 10);
    const minutes = parseInt(minutesStr, 10);
    return !isNaN(hours) && !isNaN(minutes) && hours >= 0 && hours <= 23 && minutes >= 0 && minutes <= 59;
  }

  get showMask(): boolean {
    return this.hasFocus || !!this.timeValue;
  }
}
